import PropTypes from 'prop-types'
import Control from 'react-bootstrap/FormControl'

import { errorHelper } from './helpers'

const Text = ({
  autoComplete,
  defaultValue,
  field: {
    errorId,
    isInvalid,
    isReadOnly,
    isRequired,
    name,
    register,
  },
  hasValidation = true,
  onChange,
  placeHolder,
}) => {

  let errorProps = {}

  if (hasValidation) {
    errorProps = errorHelper({ errorId, isInvalid })
  }

  return (
    <Control
      aria-describedby={errorId}
      aria-required={isRequired}
      autoComplete={autoComplete}
      defaultValue={defaultValue}
      id={name}
      isInvalid={isInvalid && hasValidation}
      name={name}
      placeholder={placeHolder}
      readOnly={isReadOnly}
      required={isRequired}
      type='text'
      {...errorProps}
      {...register(name, { onChange: onChange })}
    />
  )
}

export default Text

Text.propTypes = {
  autoComplete: PropTypes.string,
  defaultValue: PropTypes.string,
  errorOverride: PropTypes.string,
  field: PropTypes.shape({
    errorId: PropTypes.string.isRequired,
    isInvalid: PropTypes.bool.isRequired,
    isReadOnly: PropTypes.bool.isRequired,
    isRequired: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    register: PropTypes.func.isRequired,
  }),
  hasValidation: PropTypes.bool,
  onChange: PropTypes.func,
  placeHolder: PropTypes.string
}
